import { GlobalNavigationMenu } from '@diritto/common/navigation/constant';
import { GlobalNavigationMenuHref } from 'constants/navigation';

export const getMatchedMenu = (path: string) => {
  if (path === '/' || path === GlobalNavigationMenuHref[GlobalNavigationMenu.Home]) {
    return GlobalNavigationMenu.Home;
  }

  let result;
  Object.entries(GlobalNavigationMenuHref).forEach(([key, value]) => {
    if (path?.startsWith(value)) {
      result = key as GlobalNavigationMenu;
    }
  });
  return result === GlobalNavigationMenu.Home ? undefined : result;
};
